import { useState } from "react";

import { ManageSubscriptionModal } from "@/components/modals/manage-subscription-modal";
import { Button, type ButtonProps } from "@/ui";

export const SubscriptionManagerButton = ({ children, ...props }: ButtonProps) => {
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

  return (
    <>
      <ManageSubscriptionModal
        closeModal={() => {
          return setIsSubscriptionModalOpen(false);
        }}
        isOpen={isSubscriptionModalOpen}
      />
      <Button
        onClick={() => {
          return setIsSubscriptionModalOpen(true);
        }}
        {...props}
      >
        {children}
      </Button>
    </>
  );
};
